import moment from "moment";
import { construirHojaTabla, descargarLibro, limpiarNombreArchivo, texto, identificador, numero, moneda, fecha } from "../../../../Components/ExcelTablaReporte";

// Excel de los reportes CMMS: una hoja por tabla, con la misma estructura que se ve en
// pantalla (definicionesReportes.js). Usa la plomeria compartida de ExcelTablaReporte:
// encabezados Biwo, formato Contabilidad en dinero y celdas numericas reales.

const celda = (valor, tipo) => {
    if (valor === null || valor === undefined || valor === "") return tipo === "moneda" ? moneda(null) : texto("");
    switch (tipo) {
        case "moneda":
            return moneda(valor);
        case "numero":
            return numero(valor);
        case "porcentaje":
            return numero(Math.round(Number(valor) * 1000) / 10);
        case "fecha":
            return fecha(valor);
        case "fechaHora":
            return texto(moment(valor).format("DD/MM/YYYY HH:mm"));
        case "identificador":
            return identificador(valor);
        default:
            return texto(valor);
    }
};

const tipoExcel = (tipo) => (tipo === "porcentaje" ? "numero" : tipo === "fechaHora" ? "texto" : tipo);

export const descargarReporteExcel = ({ titulo, tablas, empresaNombre, descripcionFiltros }) => {
    const hojas = tablas.map((tb) => {
        const columnas = tb.columnas.map((c) => ({ titulo: c.tipo === "porcentaje" ? `${c.titulo} (%)` : c.titulo, tipo: tipoExcel(c.tipo), ancho: c.ancho }));
        const filas = tb.filas.map((f) => f.map((v, i) => celda(v, tb.columnas[i]?.tipo)));
        // Totales como un renglon resaltado (el total nativo de la hoja solo sabe de dinero).
        if (tb.totales && filas.length) filas.push(tb.totales.map((v, i) => ({ ...celda(v, tb.columnas[i]?.tipo), resalte: "subtotal" })));
        return {
            nombre: tb.hoja || tb.titulo,
            hoja: construirHojaTabla(
                { columnas, filas, totales: null },
                { titulo: `${titulo} · ${tb.titulo}`, empresaNombre, descripcionFiltros, sinAutofiltro: !!tb.totales, registros: tb.filas.length }
            ),
        };
    });
    descargarLibro(hojas, `${limpiarNombreArchivo(titulo)}_${moment().format("YYYYMMDD")}`);
};
